import * as yup from 'yup';

// Add method
yup.addMethod(yup.string, 'stripEmptyString', function () {
    return this.transform(value => (typeof value === 'string' ? value.trim() : value))
});



export const validationsSchemaHelpdesk = (selectsState, formularioFinal) => {
  let schema = {
    id_hd2_organizacion: yup.string().stripEmptyString().required('Este campo es requerido'),
    title: yup.string().stripEmptyString().required('Este campo es requerido'),
    description: yup.string().stripEmptyString().required('Este campo es requerido'), 
    evidence: yup.string().nullable(),   
  };

  if (formularioFinal) {    
    schema.destinatario = yup.string().stripEmptyString().required('Este campo es requerido');
    schema.direccion = yup.string().stripEmptyString().required('Este campo es requerido');
    schema.fecha_entrega = yup.string().stripEmptyString().required('Este campo es requerido');
    schema.requiere_evidencia = yup.string().stripEmptyString().required('Este campo es requerido');
    schema.type_msj = yup.string().stripEmptyString().required('Este campo es requerido');
  }
  
  selectsState.forEach((sel, index) => {
    schema[`area_nivel_${index}`] = yup.string().when('id_hd2_organizacion', {
      is: (value) => !!value, 
      then: (schema) => schema.required('Este campo es requerido'),
      otherwise: (schema) => schema.nullable(),
    });
  });

  return yup.object().shape(schema);
};

export const validationsSchemaHelpdeskActions = (action, caseS) => {
  if (!action) {
    return yup.object().shape({});
  }

  const shape = {};
  action.fields.forEach(field => {

    const shouldBeHidden = () => {
      return (
        action.id === "reasignar" &&
        (caseS.id_hd2_status === 2 || caseS.id_hd2_status === 5) &&
        field.id === "hide"
      );
    };
    
    let fieldSchema;

    if (field.type === 'select') { 
      fieldSchema = yup.string().required(`El campo ${field.name} es requerido`);
    } 
    
    if(field.type === 'select2') {

      fieldSchema = yup.string().test(
          'is-required-if-visible', 
          `El campo ${field.label} es requerido`, 
          function(value) {
            if (shouldBeHidden()) {            
              return true; 
            }
            if (field.type === 'select2') {
              return value !== null && value !== undefined && value !== '';
            }
            return !!value; 
          }
        );  
    }
    
    if (field.type === 'textarea' || field.type === 'date') {
       fieldSchema = yup.string().required(`El campo ${field.name} es requerido`);
    }

    
    shape[field.name] = fieldSchema;
  });
  
  shape.id_hd2_case = yup.string().required();
  shape.user_id = yup.string().required();
  shape.user_register = yup.string().required();
  shape.id_organizacion = yup.string().required();

  return yup.object().shape(shape);
}
